
import { Dialog } from "@/lib/utils";
import { SimpleDialogProps } from "@@/ui/SimpleDialog.vue";
import SimpleDialog from "@/components/ui/SimpleDialog.vue";

import Vue from "vue";

export default Vue.extend<Data, Methods, Computed, Props>({
    props: {
        novelId: String,
        plotMakerId: String,
    },
    computed: {
        frameSrc() {
            const sampleParams = new URLSearchParams();
            sampleParams.set("novelId", this.novelId);
            if (this.plotMakerId) {
                sampleParams.set("plotMakerId", this.plotMakerId);
            }
            return `/inline-frame/plot-maker?${sampleParams.toString()}`;
        }
    },
    methods: {
        beforeLeave(e: Event) {
            // iframe内のisModifiedがtrueの場合は確認ダイアログを表示する
            const { isModified } = (document.querySelector(".plot-maker-frame") as HTMLIFrameElement).contentWindow as any;
            if (isModified) {
                e.preventDefault();
                return "";
            }
        },
        showLeaveConfirmDialog(next) {
            const confirmDialog = new Dialog(SimpleDialog);
            const options: SimpleDialogProps = {
                title: "保存していないデータが存在します。",
                content: "保存されていないデータは破棄されます。\nこのまま画面遷移しますか？",
                negative: "キャンセル",
                positive: "遷移する",
                positiveCallback: () => {
                    next();
                },
            };

            confirmDialog.show(options);
        },
    },
    mounted() {
        window.addEventListener("beforeunload", this.beforeLeave);
        document.documentElement.classList.add('plot-maker-page');
    },
    beforeDestroy() {
        window.removeEventListener("beforeunload", this.beforeLeave);
        document.documentElement.classList.remove('plot-maker-page');
    },

    beforeRouteLeave(to, from, next) {
        const { isModified } = (document.querySelector(".plot-maker-frame") as HTMLIFrameElement).contentWindow as any;
        if (!isModified) {
            next();
            return;
        }

        this.showLeaveConfirmDialog(next);
    },
});

interface Props {
    novelId: string;
    plotMakerId?: string;
}

interface Data { }

interface Computed {
    frameSrc: string;
}

interface Methods {
    beforeLeave(e: Event): any;
    showLeaveConfirmDialog(next: any): void;
}

